import { RouteDefinition } from "@solidjs/router";
import { lazy } from "solid-js";

export const sharingRoutes: RouteDefinition[] = [
  {
    path: "/share/fb2497ab-7b8e-4cb8-91e2-2e13f180a15a",
    component: lazy(() => import("../components/ShareSecretUrl.js")),
  },
];
